export default class InputIcons {
  constructor(active, inactive, error) {
    this.active = active;
    this.inactive = inactive;
    this.error = error;
  }
}
